// Do not edit.
import { ShaderStore } from "core/Engines/shaderStore";
import "../ShadersWGSL/ShadersInclude/atmosphereUboDeclaration";
import "core/ShadersWGSL/ShadersInclude/helperFunctions";
import "../ShadersWGSL/ShadersInclude/atmosphereFunctions";
import "core/ShadersWGSL/ShadersInclude/importanceSampling";
import "core/ShadersWGSL/ShadersInclude/pbrBRDFFunctions";
import "core/ShadersWGSL/ShadersInclude/hdrFilteringFunctions";

const name = "diffuseSkyIrradiancePixelShader";
const shader = `const DiffuseSkyIrradianceLutSampleCount=32;
#include<atmosphereUboDeclaration>
var transmittanceLutSampler: sampler;var transmittanceLut: texture_2d<f32>;var multiScatteringLutSampler: sampler;var multiScatteringLut: texture_2d<f32>;
#include<helperFunctions>
#include<atmosphereFunctions>
fn integrateForIrradiance(directionToLightParam: vec3f,rayDirection: vec3f,rayOrigin: vec3f)->vec3f {var transmittance: vec3f;let radiance=integrateScatteredRadiance(
false,
1.,
transmittanceLut,
multiScatteringLut,
atmosphere.multiScatteringIntensity,
rayOrigin,
rayDirection.xzy,
directionToLightParam.xzy,
100000000.,
DiffuseSkyIrradianceLutSampleCount,
-1.,
&transmittance);return radiance;}
#include<importanceSampling>
#include<pbrBRDFFunctions>
#include<hdrFilteringFunctions>
varying vUV: vec2f;@fragment
fn main(input: FragmentInputs)->FragmentOutputs {let unit=uvToUnit(input.vUV,DiffuseSkyIrradianceLutDomainInUVSpace,DiffuseSkyIrradianceLutHalfTexelSize);let cosLightInclination=2.*unit.x-1.;let sinLightInclination=sqrtClamped(1.-cosLightInclination*cosLightInclination);let directionToLight=normalize(vec3f(0.,cosLightInclination,sinLightInclination));let radius=max(atmosphere.planetRadiusWithOffset,unit.y*atmosphere.atmosphereThickness+atmosphere.planetRadius);let swappedDirectionToLight=vec3f(directionToLight.x,directionToLight.z,directionToLight.y); 
var irradianceResult=PI*irradiance(
swappedDirectionToLight,
vec2f(radius,0.),
1.,
vec3f(1.),
vec3f(1.));let averageIrradiance=getLuminance(irradianceResult);let newIrradiance=mix(irradianceResult,vec3f(averageIrradiance),atmosphere.diffuseSkyIrradianceDesaturationFactor);let newIrradianceScale=getLuminance(newIrradiance);let rescaling=averageIrradiance/max(0.000001,newIrradianceScale);irradianceResult=newIrradiance*rescaling;fragmentOutputs.color=vec4f(irradianceResult,1.);}
`;
// Sideeffect
if (!ShaderStore.ShadersStoreWGSL[name]) {
    ShaderStore.ShadersStoreWGSL[name] = shader;
}
/** @internal */
export const diffuseSkyIrradiancePixelShaderWGSL = { name, shader };
